import { Component, AfterContentInit, OnInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { ProcurementProjectLotDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { UIService } from '../../ui.service';
import { Configuration } from '../../conf/app.constants';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'searchLotsAwardsPopup',
  templateUrl: 'searchLotsAwardsPopup.template.html'
})
export class SearchLotsAwardsPopupComponent extends BaseComponent implements OnInit, OnDestroy {


  loaded = false;
  //Numero de expediente
  contractFolderId: String;

  // Lote de la categoria seleccionada
  lotId: number;

  // lotes adjudicados seleccionados
  selectesObject: ProcurementProjectLotDTO[];
  //lotes adjudicados a mostrar al usuario para que los seleccione
  lotsAwards: ProcurementProjectLotDTO[];
  lotzero: boolean;
  notAwards: boolean;
  //columnas internacionalizadas
  colHeaders: string[];
  origin: string;

  constructor(
    public ref: DynamicDialogRef,
    public uiService: UIService,
    private configuration: Configuration,
    public dialogConfig: DynamicDialogConfig,
    private plycaErrorHandler: PlycaErrorHandler,
    private plycaService: PlycaDataService
  ) {
    super();
    this.contractFolderId = dialogConfig['contractFolderId'];
    this.origin = dialogConfig['origin'];
    this.lotId = dialogConfig['lotId'];

    this.colHeaders = [
      'ProcurementProjectLot.id',
      'ProcurementProjectLot.description',
      'ProcurementProjectLot.notLotsAward' + this.origin,
      'ProcurementProjectLot.not' + this.origin
    ];
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  loadData() {

    //cargar los lotes adjudicados del expediente
    let procurementProjectUrl = this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION + '?contractFolderId=' + this.contractFolderId + '&awards=true';
    if (this.lotId === 0) {
      procurementProjectUrl = this.configuration.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION + '?contractFolderId=' + this.contractFolderId + '&awards=false';
    }
    this.subscribe(this.plycaService.query<ProcurementProjectLotDTO>(procurementProjectUrl),
      (result: PaginationDTO<ProcurementProjectLotDTO>) => {

        if (result && result.content) {
          // Se filtra por el lote
          if (this.lotId != undefined && this.lotId != null) {
            //this.lotsAwards = result.content;
            this.lotsAwards = [];
            result.content.forEach(
              (procurementProjectLot: ProcurementProjectLotDTO) => {
                if (procurementProjectLot.lotId == this.lotId) {
                  this.lotsAwards.push(procurementProjectLot);
                  if (this.lotsAwards[0].lotId == 0) {
                    this.lotzero = true;
                  } else {
                    this.lotzero = false;
                  }
                }
              }
            );
          } else {
            // Sino se ha filtrado por el lote se los trae todos
            this.lotsAwards = result.content;
            if (this.lotsAwards[0].lotId == 0) {
              this.lotzero = true;
            } else {
              this.lotzero = false;
            }
          }
        } else {
          this.notAwards = true;
        }
        this.loaded = true;
      }, (error: any) => this.plycaErrorHandler.showServerError(error));

  }
  isLoaded() {
    return this.loaded;
  }
  close(selectesObject: number[]) {
    if (selectesObject) {
      this.ref.close(this.selectesObject);
    } else {
      this.ref.close();
    }
  }

}